import React, { useState, useContext, createContext } from "react";
import { useGlobal } from "reactn";
import { useTranslation } from 'react-i18next';
import { useApi } from 'stores/api';
import useLocalStorage from "stores/useLocalStorage.js";

const authContext = createContext();

export function ProvideAuth({ children }) {
  const auth = useProvideAuth();
  return <authContext.Provider value={auth}>{children}</authContext.Provider>;
}

export const useAuth = () => {
  return useContext(authContext);
};

function useProvideAuth() {
  const { t } = useTranslation(['siteheader']);
  const api = useApi();
  let loginTimer;
  const [LSIsGuestBooking, setLSIsGuestBooking] = useLocalStorage('ls_igb');
  const [isPending, setIsPending] = useState(true);
  const [modalProps, setModalProps] = useGlobal('modalProps');
  const [isAutoLoggedOut, setIsAutoLoggedOut] = useGlobal('isAutoLoggedOut');
  const [user, setUser] = useState(null);

  const login = async () => {
    const authUser = await api.getAuthUser();
    if (authUser && authUser.AccountUsername) {
      setUser(authUser);
      setLSIsGuestBooking(false);
      setTimeout(initLoginTimer, 5 * 60000);
      return true;
    } else {
      return false;
    }   
  }

  const isLoggedIn = () => {
    return user ? true : false;
  }

  const initLogin = async () => {
    const authUser = await api.getAuthUser();
    if (authUser && authUser.AccountUsername) {
      setUser(authUser);
      setTimeout(initLoginTimer, 5 * 60000);
    }
  }

  const initLoginTimer = () => {
    console.log('inited login timer.')
    loginTimer = setInterval(async () => {
      const authUser = await api.getAuthUser();
      if (!authUser) {
        console.log('YOU HAVE BEEN LOGGED OUT....');
        setUser(false);
        setModalProps({ ...modalProps, showModal: true, messages: [t("loggedOut")] });
        setIsAutoLoggedOut(true);
        clearTimer();
      }
    }, 5 * 60000);    //every 5 minutes
  }

  const clearTimer = () => {
    clearInterval(loginTimer);
  }

  const logout = async () => {
    try {
      await window.OidcMgr.signoutRedirect();
      setUser(false);
      //setLSIsGuestBooking(true);
      api.clearOrder();
      return true;      
    } catch (error) {
      console.error(error);
      setModalProps({ ...modalProps, showModal: true, messages: [error] });
      return false;
    }
  }

  const register = () => {
    setUser(false);
  }

  return {
    isPending,
    user,
    login,
    logout,
    register,
    isLoggedIn,
    initLogin,
    initLoginTimer
  };

}
